import { useContext } from "react";
import { GlobalStateContext, IMachineProvider } from ".";
import { IStateCustom } from "machine/types/types";
import {
  TCheckoutContext,
  TCheckoutEvent,
} from "../../containers/Checkout/machine/types";
import { TAppContext, TAppEvent } from "containers/app/machine/types";
import { TResultContext, TResultEvent } from "containers/Result/machine/types";

export const useProviderContext = () => {
  const context = useContext(GlobalStateContext) as IMachineProvider;
  const AppState = context.AppState as IStateCustom<
    TAppContext,
    TAppEvent
  >;
  const CheckoutState = context.CheckoutState as IStateCustom<
    TCheckoutContext,
    TCheckoutEvent
  >;
  const ResultState = context.ResultState as IStateCustom<
    TResultContext,
    TResultEvent
  >;
  return { ...context, AppState, CheckoutState, ResultState };
};
export type TMachine = typeof useProviderContext;
